module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paper-question"
  }, [(_vm.webloading) ? _c('img', {
    staticClass: "loading",
    attrs: {
      "src": require("./../../assets/img/loading.gif")
    }
  }) : _c('div', {
    staticClass: "exampaperInfo"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.exampaper.title))]), _vm._v(" "), (_vm.page == 'selectOnlinePaper' || _vm.page == 'checkOnlinePaper') ? _c('span', {
    class: {
      paperBtn: _vm.paperBtnInfo, paperBtnActive: !_vm.paperBtnInfo
    },
    on: {
      "click": _vm.paperInfo
    }
  }, [_vm._v("试卷信息")]) : _vm._e(), _vm._v(" "), (_vm.page == 'selectOnlinePaper' || _vm.page == 'checkOnlinePaper') ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.paperBtnInfo),
      expression: "!paperBtnInfo"
    }],
    staticClass: "examPaper"
  }, [_c('div', {
    staticClass: "exam_top"
  }, [(_vm.exampaper.ref_score) ? _c('span', [_c('b', [_vm._v("总分:")]), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.exampaper.ref_score) + "分")])]) : _vm._e(), _vm._v(" "), _c('span', [_c('b', [_vm._v("总难度:")]), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.exampaper.difficultyDegree))])]), _vm._v(" "), _c('span', [_c('b', [_vm._v("总答题时间:")]), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.exampaper.ref_answer_time) + "分")])])]), _vm._v(" "), _c('div', {
    staticClass: "exam_tag"
  }, [(_vm.exampaper.videoReview) ? _c('div', [(_vm.videoPlay && _vm.exampaper.videoReview.coverUrl != null) ? _c('div', {
    staticClass: "coverUrl",
    on: {
      "click": _vm.videoPlayer
    }
  }, [_c('img', {
    staticClass: "coverUrl",
    attrs: {
      "src": _vm.exampaper.videoReview.coverUrl
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "coverUrlPlay",
    attrs: {
      "src": require("./../../assets/img/player.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.exampaper.videoReview.videoUnique != null && !_vm.videoPlay) ? _c('embed', {
    attrs: {
      "src": "http://yuntv.letv.com/bcloud.swf",
      "allowFullScreen": "true",
      "quality": "high",
      "width": "300",
      "height": "150",
      "align": "middle",
      "allowScriptAccess": "always",
      "flashvars": _vm.videoSrc(_vm.exampaper.videoReview.videoUnique),
      "type": "application/x-shockwave-flash"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.exampaper.testItems.length > 0) ? _c('ul', {
    staticClass: "exam_testItems"
  }, [_c('b', [_vm._v("考点信息:")]), _vm._v(" "), _vm._l((_vm.exampaper.testItems), function(item, index) {
    return _c('li', [_c('p', {
      staticClass: "paperInfoT"
    }, [_vm._v("• " + _vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "paperInfoC"
    }, [_vm._v(_vm._s(item.content))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.exampaper.tags) ? _c('ul', {
    staticClass: "exam_tags"
  }, [_c('b', {
    staticClass: "paperInfoT"
  }, [_vm._v("来源")]), _vm._v(" "), _vm._l((_vm.exampaper.tags), function(item, index) {
    return _c('li', {
      staticClass: "paperInfoTag"
    }, [_vm._v("\n                                " + _vm._s(item) + "\n                            ")])
  })], 2) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.exampaper.parts), function(part, index) {
    return _c('div', {
      staticClass: "p-20 bg-fff border"
    }, [(_vm.page == 'selectListenSpeak' && _vm.selectFlag) ? _c('div', {
      staticClass: "fr"
    }, [_c('div', {
      staticClass: "button choice",
      class: {
        'checkedSel': part.isChecked, 'noCheck': !part.isChecked
      },
      on: {
        "click": function($event) {
          _vm.choiceBigQ(part, index)
        }
      }
    }, [_vm._v(_vm._s(part.buttonText))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "m-t10"
    }, [_c('p', {
      staticClass: "qDescript",
      domProps: {
        "innerHTML": _vm._s(part.module_description)
      }
    }), _vm._v(" "), (_vm.moduleId != 15) ? _c('p', {
      staticClass: "queNum"
    }, [_vm._v(_vm._s(_vm.questionNum[index]) + "、 (共 " + _vm._s(part.question_ref_sorce) + " 分, " + _vm._s(part.difficultyDegree) + " 难度)")]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "qtypeName",
      domProps: {
        "innerHTML": _vm._s(part.module_type_name)
      }
    })]), _vm._v(" "), _vm._l((part.children), function(question, index) {
      return _c('div', {
        staticClass: "mt-20"
      }, [(question.qtype == 1) ? _c('singleChoice', {
        attrs: {
          "playerObj": _vm.playerObj,
          "question": question,
          "moduleId": _vm.moduleId,
          "id": question.id + index,
          "isShowAnswer": _vm.isShowAnswer
        },
        on: {
          "playedObj": _vm.playedObj
        }
      }) : (question.qtype == 2) ? _c('multipleChoice', {
        attrs: {
          "playerObj": _vm.playerObj,
          "id": question.id + index,
          "question": question,
          "moduleId": _vm.moduleId,
          "isShowAnswer": _vm.isShowAnswer
        },
        on: {
          "playedObj": _vm.playedObj
        }
      }) : (question.qtype == 3) ? _c('filling', {
        attrs: {
          "playerObj": _vm.playerObj,
          "id": question.id + index,
          "page": _vm.page,
          "question": question,
          "moduleId": _vm.moduleId,
          "isShowAnswer": _vm.isShowAnswer
        },
        on: {
          "playedObj": _vm.playedObj,
          "correctScore": _vm.correctScore
        }
      }) : (question.qtype == 4 || question.qtype == 9 || question.qtype == 10) ? _c('allFilling', {
        attrs: {
          "qtype": 9,
          "playerObj": _vm.playerObj,
          "id": question.id + index,
          "page": _vm.page,
          "question": question,
          "moduleId": _vm.moduleId,
          "isShowAnswer": _vm.isShowAnswer
        },
        on: {
          "playedObj": _vm.playedObj
        }
      }) : (question.qtype == 5) ? _c('reading', {
        attrs: {
          "playerObj": _vm.playerObj,
          "id": question.id + index,
          "question": question,
          "moduleId": _vm.moduleId,
          "isShowAnswer": _vm.isShowAnswer
        },
        on: {
          "playedObj": _vm.playedObj,
          "correctScore": _vm.correctScore
        }
      }) : (question.qtype == 6) ? _c('shortanswer', {
        attrs: {
          "playerObj": _vm.playerObj,
          "id": question.id + index,
          "page": _vm.page,
          "question": question,
          "moduleId": _vm.moduleId,
          "isShowAnswer": _vm.isShowAnswer,
          "padShow": _vm.padShow
        },
        on: {
          "playedObj": _vm.playedObj,
          "correctScore": _vm.correctScore
        }
      }) : (question.qtype == 7) ? _c('imitation', {
        attrs: {
          "playerObj": _vm.playerObj,
          "id": question.id + index,
          "question": question,
          "moduleId": _vm.moduleId,
          "isShowAnswer": _vm.isShowAnswer
        },
        on: {
          "playedObj": _vm.playedObj,
          "correctScore": _vm.correctScore
        }
      }) : (question.qtype == 8) ? _c('judge', {
        attrs: {
          "playerObj": _vm.playerObj,
          "id": question.id + index,
          "question": question,
          "moduleId": _vm.moduleId,
          "isShowAnswer": _vm.isShowAnswer
        },
        on: {
          "playedObj": _vm.playedObj
        }
      }) : _vm._e()], 1)
    })], 2)
  })], 2), _vm._v(" "), ((_vm.page == 'selectListenSpeak' || _vm.page == 'selectOnlinePaper') && this.thirdParty) ? _c('div', {
    staticClass: "m-select-question",
    class: {
      relativeBox: _vm.barHide
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }, [(_vm.selectedExampaperArr.length) ? _c('div', {
    staticClass: "fl"
  }, [_vm._v("共选 " + _vm._s(_vm.selectedExampaperArr.length || 0) + " 条内容，预计\n                "), _c('span', {
    staticStyle: {
      "padding": "0px 5px"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("formatDataToMinutes")(_vm.doworkTime)) + " ")]), _vm._v("分钟")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [(_vm.selectFlag) ? _c('div', {
    staticClass: "inline-block",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button inline-block m-l20 surebtn",
    on: {
      "click": _vm.backQuestionArr
    }
  }, [_vm._v("确定")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-621b374a","hasScoped":false}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/question/exampaper.vue
// module id = 191
// module chunks = 1